<template>
  <div id="list-item" class="e-list-wrapper  e-list-multi-line ">
    <span class="item-title e-list-item-header">{{data.text}}</span>
    <span class="list-sub-text e-list-content">{{data.ecrNumber}}_{{ data.rev }} - {{data.status}}</span>
  </div>
</template>

<script>
export default {
  data () {
    return {
        data: {}
    }
  }
}
</script>

<style scoped>
/* .list-item {
}*/
.item-title {
  display: block;
  font-weight: bold;
  font-size: 1.2em;
  margin-bottom: 0;
  padding-bottom: 0;
}

.item-sub-text {
  display: block;
  font-size: 0.8em;
  margin-top: 0;
  padding-top: 0;
} 
</style>